module.exports = __webpack_public_path__ + "img/Profile Dropdown.b2c90c02.svg";